
//PhoneField

import React from 'react';

function PhoneField({ value, onChange }) {
  // Função para formatar o número de telefone com DDD
  const formatPhoneNumber = (phoneNumber) => {
    // Remove todos os caracteres não numéricos do número de telefone
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    // Formatar o número de telefone com o DDD
    const formatted = cleaned.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
    return formatted;
  };

  // Manipulador de mudança de telefone
  const handlePhoneChange = (e) => {
    // Obter o número de telefone digitado pelo usuário
    const rawValue = e.target.value;
    // Formatá-lo usando a função de formatação
    const formattedValue = formatPhoneNumber(rawValue);
    // Chamar a função de mudança de prop com o valor formatado
    onChange(formattedValue);
  };

  return (
    <input
      type="text"
      placeholder="(xx) xxxxx-xxxx"
      value={value}
      onChange={handlePhoneChange}
      style={{
        width: '200px',
        height: '30px',
        border: '1px solid black',
        marginBottom: '0px',
        fontSize: '16px', // Ajustar o tamanho da fonte conforme necessário
      }}
    />
  );
}

export default PhoneField;